<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TKMN5a/tc-custom/9781526772114.jpg?1709608782645" alt="This image is the cover for the book Forts and Roman Strategy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forts and Roman Strategy
      </h1>
      <p class="bookDescription body article font2">
        <p>Paul Coby here proposes a new system for the recording and mapping of Roman forts and fortifications that integrates all the data, including size, dating and identification of occupying units.  Application of these methods allows analysis that brings new insights into the placement of these forts, the units garrisoning them and the strategy of conquest and defense they underpinned.   This is a new and original contribution to the long-running debate over whether the Roman Empire had a coherent grand strategy or merely reacted piecemeal to emerging needs. Although the author focuses on several major campaigns in Britain as case studies, the author stresses that his method's are also applicable to elsewhere in the Empire. Lavishly illustrated with color maps, the book is also supported by a website and blogs, encouraging further investigation and discussion.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Coby, M.C. Bishop
      </h2>
      
      <p class="authorDescription body article">After a career in the British civil service in roles including transport policy, Paul Coby became Chief Information Officer in charge of digital technology at British Airways and then the John Lewis Partnership. In 2018 he joined Johnson Matthey, a global leader in sustainable technologies, as CIO. He is also a member of the advisory panel of AND Digital, a digital accelerator in the UK and Europe.  He believes that his experience in digital technology has enabled him to deploy data analysis and visualisation to the Roman Army’s campaign methods and to apply organisational theory to how the Roman military machine thought.  He has always been fascinated by the Roman Army and how it succeeded in controlling an empire from the Highlands of Scotland to the deserts of Arabia. He continues to deploy up-to-date data analysis techniques to Roman forts and campaigns to generate new insights into the mind of the Roman military machine, now turning to the Roman Limes in Germany and Romania, as well as the Roman Army's response to Boudica’s Revolt and the dense network of forts in Northern England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00f3a891